import styled from "styled-components";

export const MainContainer = styled.div`
  background-color: #f2f4fa;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 50px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 1200px;
  align-items: flex-start;
  padding: 1em;
`;
